
import React, { useState } from 'react';
import SplashScreenContainer from './splashScreen/splashScreenContainer';
import { useLoadLinkInfo } from '../commonUtil/hookUtil';
import { initialSession, hasInitializedSessionTimer } from '../commonUtil/sessionUtil';
import SessionExpiredPage from '../components/sessionExpiredPage';
import SessionExpiringModal from '../components/sessionExpiringModal';
import { getCompliancePwdCookie } from '../commonUtil/cookieUtil';
import ViewerContainer from '../components/viewerContainer';
import ErrorPage from './errorPage';
import GDPRConsentLocation from '../model/gdprConsentLocation';
import ExplicitSplash from './explicitSplash';
import { setNewrelicCustomAttribute, executeNewrelicTracerForOthers } from '../commonUtil/newrelicTracer';
import { isNoTrackView } from '../commonUtil/util';

export default function EngagementViewerComponent(props) {
    const { humanEvent } = props;
    const [sessionTimeout, setSessionTimeout] = useState(false);
    const [isOpenSessionExpired, setIsOpenSessionExpired] = useState(false);
    const [showExplicitSplash, setShowExplicitSplash] = useState(true);

    const { state } = useLoadLinkInfo(humanEvent);
    const { linkBasicInfo, isLoadingLink, viewerSetting, error,
        gdprSetting, isLoadingScript, skipSplashScreen } = state;
    const { isExpired } = linkBasicInfo || {};

    const handleSessionTimeOut = () => {
        setIsOpenSessionExpired(true);
    };

    const afterSessionEnd = () => {
        setSessionTimeout(true);
    };

    if (!hasInitializedSessionTimer()) {
        initialSession(handleSessionTimeOut);
    }

    if (error) {
        setNewrelicCustomAttribute('engagementviewer', 'error page');
        try {
            return (
                <div className="seismic-engagement-viewer-error-container" >
                    <ErrorPage errorCode={error.errorCode} />
                </div>
            );
        } finally {
            executeNewrelicTracerForOthers();
        }
    }

    if (isLoadingLink) {
        return <div className="engagement-viewer-busy-spinner" />;
    }

    if (sessionTimeout) {
        return <SessionExpiredPage />;
    }

    if (!skipSplashScreen) {
        setNewrelicCustomAttribute('engagementviewer', 'splash screen');
        try {
            if (!isNoTrackView() && gdprSetting && gdprSetting.consentLocation === GDPRConsentLocation.EXPLICIT &&
                !(window.mscc && window.mscc.hasConsent()) && showExplicitSplash) {
                if (isLoadingScript) {
                    return <div className="engagement-viewer-busy-spinner" />;
                }

                return (<ExplicitSplash setShowExplicitSplash={setShowExplicitSplash} />);
            }

            return (
                <SplashScreenContainer
                    key="LinkSplashScreen" />
            );
        } finally {
            executeNewrelicTracerForOthers();
        }
    } else if (!isExpired || (isExpired && getCompliancePwdCookie())) {
        setNewrelicCustomAttribute('engagementviewer', 'open content');
    }

    return ([
        <ViewerContainer key="ViewerContainer" />,
        <SessionExpiringModal key="SessionExpiredModal"
            isOpen={isOpenSessionExpired}
            setIsOpen={setIsOpenSessionExpired}
            brandingHilightColor={viewerSetting.brandingHilightColor}
            afterSessionEnd={afterSessionEnd} />
    ]);
}
